/** Extract a tour category id from string, populated object, or ObjectId-like value. */
export function extractCategoryId(category: unknown): string {
  if (category == null) return ''
  if (typeof category === 'string') return category.trim()
  if (typeof category === 'object') {
    const obj = category as { _id?: unknown; id?: unknown }
    if (obj._id != null) return String(obj._id).trim()
    if (obj.id != null) return String(obj.id).trim()
  }
  const asString = String(category).trim()
  return asString && asString !== '[object Object]' ? asString : ''
}

/** Normalize category field to a flat list of category ids. */
export function extractCategoryIds(categories: unknown): string[] {
  if (categories == null) return []
  const list = Array.isArray(categories) ? categories : [categories]
  return list.map(extractCategoryId).filter(Boolean)
}

/** Normalize category field to id list for API submit. */
export function categoryIdsForSubmit(categories: unknown): string[] {
  return extractCategoryIds(categories)
}
